import { getTokenInfo, getTokenInfoFromServer } from './parse-token';
import { redis } from './redis';

const LOG_LIST_PREFIX = 'api-list';

const getSubSuffix = (sub: string) => sub.split('-').pop();

export const getServerLogKeyFromServer = async () => {
  const tokenInfo = await getTokenInfoFromServer();
  if (!tokenInfo?.sub) {
    return null;
  }
  return `${LOG_LIST_PREFIX}-${getSubSuffix(tokenInfo.sub)}`;
};

export const getServerLogKeyFromClient = () => {
  const tokenInfo = getTokenInfo();
  if (!tokenInfo?.sub) {
    return null;
  }
  return `${LOG_LIST_PREFIX}-${getSubSuffix(tokenInfo.sub)}`;
};

export const reportServerLog = async (log: unknown) => {
  if (process.env.NEXT_PUBLIC_ENV === 'prod') {
    return;
  }
  try {
    const logKey = await getServerLogKeyFromServer();
    if (logKey) {
      redis.rpush(logKey, log);
    }
  } catch (e) {
    console.error('reportServerLog error', e);
  }
};
